import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout , selectProviderAuth } from "../../auth-provider/slice/providerAuth";
import { googleLogout } from '@react-oauth/google';
import { getProviderInfo, updateProviderInfo } from "../../provider-panel/slice/providerPanelSlice";
import { providerIncrementNotification, providerResetNotifications } from "../slice/providerNavigationSlice";
import Pusher from "pusher-js";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ProviderNavbar = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isProviderLoggedIn = useSelector(selectProviderAuth);
  const providerName = useSelector((state) => state.providerInfo.providersInfo?.company_name);
  const providerProfileImage = useSelector((state) => state.providerInfo.providersInfo?.profile_image);
  const providerIsVerified = useSelector((state) => state.providerInfo.providersInfo?.is_verified);
  const unreadCount = useSelector((state) => state.providerNavigation.providerUnreadCount);
    const { providerLastMessages, adminLastMessages } = useSelector(
      (state) => state.providerChatList
    );
  
       console.log("unreadCount", unreadCount);

       useEffect(() => {
               const providerToken = localStorage.getItem("provider_access_token");
               const providerId = localStorage.getItem("user_id");
               const currentUserType = "Icommunetech\\Provider\\Models\\Provider";
               if (!providerToken) return;
           
               const pusher = new Pusher("71055cc21a087085dc31", {
                 cluster: "ap2",
                 forceTLS: true,
                 authEndpoint: `${BACKEND_URL}/pusher/auth`,
               });
           
               // Subscribe to a "global" channel for this client
               const globalChannel = pusher.subscribe("private-chat_room");
           
               globalChannel.bind("App\\Events\\ChatRoomCreated", (data) => {
                if (String(data?.to_id) === String(providerId)) {
                  dispatch(providerIncrementNotification());
                }
                //  dispatch(providerIncrementNotification());
               });

               const allChats = [...(providerLastMessages || []), ...(adminLastMessages || [])];
                 const chatChannels = [];
               
                 allChats.forEach((chat) => {
                   const chatChannel = pusher.subscribe(`private-chat_${chat.chat_id}`);
               
                   chatChannel.bind("App\\Events\\MessageSent", (data) => {
                     const { message } = data;
               
                     const isToMe =
                       String(message.to_id) === String(providerId) &&
                       message.to_type === currentUserType;
               
                     if (isToMe) {
                       dispatch(providerIncrementNotification());
                     }
                   });
               
                   chatChannels.push(chatChannel);
                 });
           
               return () => {
                 globalChannel.unbind_all();
                 globalChannel.unsubscribe();
                 pusher.disconnect();
               };
             }, [dispatch]);

const token = localStorage.getItem("provider_access_token");
  useEffect(() => {
    dispatch(getProviderInfo(token));
  }, [dispatch]);

const isTokenValid = () => {
  const expiryTime = localStorage.getItem("provider_token_expiry");
  if (!expiryTime) return false;

  const currentTime = new Date().getTime();
  return currentTime < parseInt(expiryTime);
};

useEffect(() => {
    const tokenValid = isTokenValid();

    if (!tokenValid) {
      dispatch(logout());
      googleLogout();
      // navigate("/provider/signin");
    } else if (token) {
      dispatch(getProviderInfo(token));
    }
  }, [dispatch, navigate, token]);

  const profileImageUrl = providerProfileImage
    ? `${process.env.REACT_APP_PROFILE_IMAGE_BACKEND_URL}/${providerProfileImage}`
    : "/assets/images/default-profile-account.jpg";

  const handleProviderLogout = () => {
    googleLogout();
    dispatch(logout());
    navigate("/provider");
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg py-2 py-lg-0">
            <div className="container position-relative px-3">
              {/* <Link to="/provider"> */}
                <a className="navbar-brand logo me-0 py-0 mb-0" href="/provider"><img src="/assets/images/logo.png" className="img-fluid" /></a>
               {/* </Link> */}
               <div className="d-flex">
                  <div className="d-lg-none"><a href="#" className="text-decoration-none"><img src="/assets/images/header-gmail.svg" alt="..." className="" /></a></div>
                  <div className="mx-3 d-lg-none"><a href="#" className="text-decoration-none"><img src="/assets/images/header-call.svg" alt="..." className="" /></a></div>
                  <button className="navbar-toggler text-danger p-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                  <img src="/assets/images/menu-arrow.png" className="img-fluid" style={{ position: "relative", top: "-2px" }} />
                  </button>
               </div>
               <div className="collapse navbar-collapse nav-menu" id="navbarCollapse">
                  <ul className="navbar-nav menu ms-auto m-0 text-capitalize font-weight-medium font-size-18 align-items-lg-center me-lg-4">
                    <li className="nav-item">
                                                  <Link className="nav-link text-white" to="/">Home</Link>
                                              </li>
                     <li className="nav-item">
                        <Link className="nav-link text-white" to="/client-services">Find a Provider</Link>
                     </li>
                     <li className="nav-item">
                        <Link className="nav-link text-white" to="#">Financial Support</Link>
                     </li>
                     <li className="nav-item">
                        <Link className="nav-link text-white" to="#">Education Hub</Link>
                     </li>
                     <li className="nav-item">
                        <Link className="nav-link text-white" to="/community">Forum</Link>
                     </li>
                    
                     {/* {isProviderLoggedIn && (
                      <li className="nav-item">
                          <Link className="nav-link text-white" to="/provider/panel/info">Panel</Link>
                      </li>
                     )} */}
                  

                  {isProviderLoggedIn && (
                    <>
                      {providerIsVerified !== 'Y' && (
                        <li className="nav-item">
                            <Link className="nav-link text-white" to="/provider/panel/verify">ID Verification</Link>
                        </li>
                      )}
                     </>
                  )}
                  </ul>

                  {isProviderLoggedIn ? (
                    // <div className="d-flex log-in">
                    //   <div className="d-flex align-items-center ps-3 ps-lg-0 py-3 py-lg-0">
                    //       <div className="d-flex align-items-center">
                    //       <div className="me-3"><img src="/assets/images/user-img.png" alt="..." className="img-fluid" /></div>
                    //       <div className="font-size-14 font-weight-normal line-hight-3 text-whightlight">
                    //         <h2 className="font-weight-semibold text-white font-size-18 mb-1 line-hight-2">{providerName || "Guest"}</h2>
                    //       </div>
                    //   </div>
                    //   </div>
                    // </div>

                    <div className="d-flex log-in">
                      <div className="d-flex align-items-center ps-3 ps-lg-0 py-3 py-lg-0">
                        <div className="d-flex align-items-center">

                          <div className="font-size-14 font-weight-normal line-hight-3 text-whightlight me-2">
                            <h2 className="font-weight-semibold text-white font-size-18 mb-0 line-hight-2">
                              {providerName || "Guest"}
                            </h2>
                          </div>

                          <div className="me-3">
                            <img src={profileImageUrl} alt="Profile" className="img-fluid" 
                            style={{
                              height: "35px",
                              width: "35px",
                              borderRadius: "8px"
                            }}
                            />
                          </div>

                          <div className="position-relative me-4">
                            <Link to='/provider/chat/client'>
                              <i className="fa fa-bell fa-lg text-white"></i>
                                  
                              {unreadCount > 0 && (
                                <span 
                                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                  style={{ fontSize: "0.7rem", minWidth: "18px" }}
                                >
                                  {unreadCount}
                                </span>
                              )}
                            </Link>
                          </div>

                          <div className="dropdown m-2">
                            <button
                              className="btn btn-sm btn-outline-light dropdown-toggle"
                              type="button"
                              id="providerDropdown"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              ☰
                            </button>

                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="providerDropdown">
                              <li>
                                <Link className="dropdown-item" to="/provider/panel/info"> My Account </Link>
                              </li>
                             <li className="mt-2">
                                <button className="dropdown-item" onClick={handleProviderLogout}>
                                  Logout
                                </button>
                              </li>
                            </ul>
                          </div>

                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex log-in">
                      <div className="d-flex align-items-center ps-3 ps-lg-0 py-3 py-lg-0">
                        <Link to="/signup">
                          <button className="btn btn-light-header font-weight-medium rounded me-2"><span className="d-block py-1 px-2">Get Started</span></button>
                        </Link>
                        {/* <Link to="/signin">
                          <button className="btn btn-outline-light font-weight-medium rounded"><span className="d-block py-1 px-2">Log In</span></button>
                        </Link> */}
                        <div className="dropdown">
                          <button className="btn btn-light-header font-weight-medium rounded" data-bs-toggle="dropdown" id="loginDropdown">
                            <span className="d-block py-1 px-2">Log In <i class="ms-1 fa fa-caret-down" aria-hidden="true"></i></span>
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="loginDropdown">
                            <li>
                              <Link className="dropdown-item py-2 px-3" to="/signin">Parent</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item py-2 px-3" to="/provider/signin">Provider</Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
               </div>
            </div>
         </nav>
    </>
  );
};

export default ProviderNavbar;
